import { gql } from '@apollo/client';

export const UPDATE_SVA_IN_OFFENSE = gql`
  mutation addOrUpdateSvaInOffense($input: AddOrUpdateSvaInOffenseInput!) {
    addOrUpdateSvaInOffense(input: $input) {
      clientMutationId
      errors
      incidentOffenseUuid
      suspectVictimAffiliationUuid
      suspectVictimAffiliation {
        biasType {
          id
          name
          oriId
          position
        }
        ibrSuspectVictimRelationshipType {
          id
          name
          oriId
          position
        }
        id
        leokaNarrative
        suspect {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        svaOri {
          abbreviation
          agencyType
          id
          oriName
        }
        victim {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        victimLeoAssignment {
          id
          name
          oriId
          position
        }
        victimLeoState {
          id
          name
          oriId
          position
        }
      }
    }
  }
`


